export default "__VITE_ASSET__Bo3wGHHp__"